// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T20:12:11.516Z
// Property: Juniper (ID: 6767906449166809)
// Collections: 28 amenities, 7 floorplans (live), 28 photos, 41 POIs, 12 reviews, 5 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166809",
  "property_external_id": "48z6ctj",
  "property_zillow_url": "https://www.zillow.com/apartments/sacramento-ca/juniper-apartments/CmPdGf/",
  "property_apartments_url": "https://www.apartments.com/juniper-sacramento-ca/48z6ctj/",
  "property_google_business_url": "https://www.google.com/maps/place/Juniper+Apartments/data=!4m2!3m1!1s0x0:0xfd6fedd131101c58?sa=X&ved=2ahUKEwj9r6Wc6KeSAxUih-4BHWa1EWwQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "33840265131",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "493RMP",
  "property_status": null,
  "property_slug": "juniper",
  "property_name": "Juniper",
  "property_website_url": "https://www.liveatthejuniper.com/",
  "property_domain": "https://www.liveatthejuniper.com/",
  "property_address": "9190 Blue Point Lane",
  "property_full_address": "9190 Blue Point Ln, Sacramento, CA 95826",
  "property_address_1": "9190 Blue Point Ln",
  "property_address_2": null,
  "property_address_city": "Sacramento",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95826",
  "property_address_country": "US",
  "property_address_county": "Sacramento County",
  "property_neighborhood_address": "Rosemont Downs",
  "property_address_latitude": "38.5442795",
  "property_address_longitude": "-121.358306",
  "property_email": null,
  "property_phone": "(916) 571-6554",
  "property_call_tracking_phone": "855-481-4361",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Welcome to Juniper Apartments.</strong> Discover spacious 1 and 2 bedroom apartments and townhomes in a tranquil, park-like gated community in Rosemont—rated 4+ stars by residents. Explore our <a href=\"/floor-plans\">floor plans</a>, then <a href=\"/schedule-a-tour\">schedule your personalized tour</a> today.</p>",
  "property_long_description": "Welcome to Juniper Apartments. Ideally located in the heart of Sacramento's desirable Rosemont area, we are close to shopping, dining, light rail, freeways and within miles of Sacramento State University. We offer spacious, well-designed 1 and 2  bedroom apartment and townhouse floorplans in a tranquil park-like setting. We were rated 4+ STARS by our residents in a nationwide resident survey. This gated community offers the best in carefree, affordable living. We would love the opportunity to introduce our community to you. Please call or stop by today for your personalized tour. We look forward to making Juniper Apartments your new home.\n\nApartments Management Consultants, Broker License # 01525033",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-b30a-774f-9528-c7a4ea447015.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at dusk.",
    "public_id": "019fa3fe-b30a-774f-9528-c7a4ea447015",
    "storage_key": "property/6767906449166809/019fa3fe-b30a-774f-9528-c7a4ea447015.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "170",
  "property_year_built": "1978",
  "property_year_renovated": null,
  "property_walk_score": "62",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.23529411764706",
  "property_admin_fee": null,
  "property_application_fee": "56",
  "property_fees_deposit_info": "$500- Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Up to 2 pets per apartment. Breed restrictions do apply.",
  "property_pet_policy_description": "Pet Policy: Up to 2 pets per apartment. Breed restrictions do apply. Pet deposit is refundable up to $200. See your community office for more details.",
  "property_petpolicy_info": "\nRefundable Pet Deposit\nPer Pet Refundable Pet Deposit\t$500.00\nPet Rent\nPer Pet Pet Rent\t$25.00\nPet Policy: Up to 2 pets per apartment. Breed restrictions do apply. Pet deposit is refundable up to $200. See your community office for more details.",
  "property_online_leasing_url": "https://myrentalapplication.com/index/amcjuniper",
  "property_resident_portal_url": "https://portal.goprisma.com/common/login?returnUrl=%2Fauth%2Flogin%3FreturnUrl%3D%252Fdashboard",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcjuniper",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d3-4c12-73d8-87a6-837c011304b8.webp",
  "property_primary_logo_media": {
    "alt_text": "Juniper Apartments logo",
    "public_id": "019d02d3-4c12-73d8-87a6-837c011304b8",
    "storage_key": "property/6767906449166809/019d02d3-4c12-73d8-87a6-837c011304b8.webp",
    "width": 475,
    "height": 95
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3e4-a679-751d-bdf8-acdc81328117.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Juniper Apartments logo",
    "public_id": "019fa3e4-a679-751d-bdf8-acdc81328117",
    "storage_key": "property/6767906449166809/019fa3e4-a679-751d-bdf8-acdc81328117.webp",
    "width": 475,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3e4-99ed-717f-8fe8-83ecaa9e2869.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Juniper Apartments logo",
    "public_id": "019fa3e4-99ed-717f-8fe8-83ecaa9e2869",
    "storage_key": "property/6767906449166809/019fa3e4-99ed-717f-8fe8-83ecaa9e2869.webp",
    "width": 475,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#426da9",
  "property_secondary_color": "#263238",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 4",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "1 - 3",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "3",
  "property_sqft_range": "537 - 1,400 sq ft",
  "property_sqft_min": "537",
  "property_sqft_max": "1,400",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/Liveatthejuniper/",
  "property_instagram_url": "https://www.instagram.com/juniper_apts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJAQpi5avEmoARWBwQMdHtb_0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Sacramento%2C+CA&start=60",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Juniper",
  "property_home_romance_title": "Experience Love at First Sight in Your Dream Apartment",
  "property_home_amenities_blurb": "<p><strong>Everyday amenities with a local touch.</strong> Juniper brings comfort outside with a refreshing pool, landscaped courtyards, shaded outdoor spaces, a small dog park, and a community vegetable garden. Inside, practical perks like in-home laundry, dishwashers, disposals, ceiling fans, and walk-in closets help keep daily routines simple—whether you’re settling into a one-bedroom apartment or a larger townhome-style layout.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore one-bedroom apartments, two-bedroom homes, and spacious three- and four-bedroom townhome-style floor plans at Juniper. Select layouts add everyday ease with in-home washer and dryer, dishwasher, ceiling fans, walk-in closets, extra bathrooms, and multi-level living. Check featured plans, compare availability, and find the space that fits your day.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview Juniper in Sacramento.</strong> Follow the gallery from tree-lined walkways and landscaped courtyards to a pool deck with blue loungers, umbrellas, and evening string lights. Inside, see bright neutral interiors with wood-look flooring, ceiling fans, white cabinetry, gray countertops, and stainless steel appliances—plus select layouts with stacked laundry and extra storage.</p>",
  "property_home_neighborhood_blurb": "<p>At Juniper, your ideal Sacramento lifestyle awaits with one to four-bedroom floor plans designed for comfort and convenience. Nestled near vibrant parks, the Sacramento Children's Museum, and California State University, enjoy a perfect blend of relaxation and adventure. Embrace community living and uncover your next favorite spot today!</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews say it best.</strong> Juniper earns shoutouts for responsive management, quick maintenance, and grounds that stay beautifully cared for. Reviews also highlight everyday extras like the pool, community garden, and small dog park, plus a Sacramento location that keeps errands, dining, and area destinations within easy reach. See why residents call Juniper an “<strong>Amazing Place to Live!</strong>”</p>",
  "property_neighborhood_blurb": "<p>Nestled in vibrant Sacramento, Juniper offers easy access to enriching experiences. Just minutes away, enjoy the tranquility of McKinley Park, energize at Urban Air Trampoline Park, or catch a game at Hornet Stadium. With California State University nearby, our community connects urban convenience with local charm. Uncover your new lifestyle!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Juniper in Sacramento, CA, every detail is designed for your comfort. Dive into relaxation at our shimmering pool or unwind in the hot tub. With spacious floor plans—from one to four bedrooms—plus top-notch amenities like 24-hour maintenance and a pet play area, your perfect home awaits. Experience a vibrant lifestyle here!</p>",
  "property_applynow_blurb": "<p>At Juniper in Sacramento, CA, choose from spacious one to four-bedroom floor plans tailored for comfort and style. Enjoy resort-style amenities like a pool, hot tub, and pet-friendly play area. With convenient online services and maintenance on-site, your perfect home awaits. Find your new space and lease online today!</p><p><br></p>",
  "property_contactus_blurb": "<p>At Juniper in Sacramento, CA, your ideal home awaits! Choose from an array of thoughtfully designed floor plans, including one to four-bedroom options tailored to fit your lifestyle. For inquiries or to learn more, reach out to our friendly leasing team today!</p>",
  "property_faqs_blurb": "<p><strong>Questions about Juniper Apartments?</strong> Start here for quick answers about our gated Sacramento community, leasing, spacious 1 and 2 bedroom apartment and townhouse floorplans, and everyday living in a tranquil park-like setting. If you need more help, our leasing team is happy to answer questions or schedule your personalized tour.</p>",
  "property_floorplans_blurb": "<p>At Juniper in Sacramento, CA, stylish living meets versatility. Choose from thoughtfully designed floor plans—one to four bedrooms—catering to every lifestyle. With spacious layouts and modern finishes, your dream home awaits. Browse our available apartment homes and find the perfect space to elevate your Sacramento experience.</p>",
  "property_gallery_blurb": "<p>At Juniper in Sacramento, CA, your dream home awaits. Choose from spacious one to four-bedroom floor plans, each featuring modern amenities like stainless steel appliances and private outdoor spaces. Relax by the pool, unwind in the hot tub, or enjoy a picnic in our beautifully landscaped courtyard. Picture yourself living here!</p>",
  "property_interactivemap_blurb": "<p>At Juniper in Sacramento, your perfect home awaits! Choose from spacious one-, two-, three-, and four-bedroom floor plans designed for comfortable living, then enjoy community amenities like a refreshing pool, pet-friendly spaces, and the convenience of on-site maintenance.</p>",
  "property_pets_blurb": "<p><strong>Pet routines feel easier at Juniper.</strong> Start with a quick lap through the landscaped community, head to the small dog park for close-to-home playtime, or unwind outside in the courtyard after a walk. Inside your apartment, practical features like in-home laundry and roomy closets help keep leashes, toys, towels, and everyday pet supplies right where you need them.</p><p>Juniper welcomes up to two pets per apartment, with breed restrictions and refundable deposit details available from the community office. Want to see the spaces your pet will use most? Explore the <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to picture daily life here in Sacramento.</p>",
  "property_referafriend_blurb": "<p><strong>Share Juniper Apartments with a friend.</strong> If you love the tranquil park-like setting, spacious 1 and 2 bedroom apartments and townhomes, and carefree living in Rosemont, invite friends to take a look. With 4+ star resident ratings, Juniper is easy to recommend.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Juniper Apartments</strong><br>Enjoy simple account management from a community known for tranquil, park-like surroundings and 4+ star resident ratings. Log in to pay rent, submit maintenance requests, and manage your Juniper account with ease.</p>",
  "property_reviews_blurb": "<p><strong>See Juniper through resident eyes.</strong> As you read through the reviews, you’ll find praise for responsive management, quick maintenance, and grounds that are consistently described as well maintained.</p><p>One resident calls Juniper an “<strong>Amazing Place to Live!</strong>” and highlights everyday conveniences like the pool, community garden, and small dog park. You’ll also see appreciation for a location that keeps Sacramento-area destinations within manageable reach—all from a community residents are happy to recommend.</p>",
  "property_created_at": "1762201534690",
  "property_scheduletour_blurb": "<p><strong>See Juniper Apartments in person.</strong> Tour spacious 1 and 2 bedroom apartments and townhomes set within a tranquil, park-like gated community in Sacramento’s Rosemont area. With 4+ star resident ratings and carefree, affordable living, Juniper is ready to welcome your visit. Schedule your personalized tour today.</p>",
  "property_thankyou_blurb": "<p>Thank you for your interest! A team member will reach out to you soon to help you find your dream home.</p>",
  "property_virtualtours_blurb": "Step into your dream home at Juniper in Sacramento, CA! With spacious one to four-bedroom floor plans, our community caters to every lifestyle. Ready to envision your new life? Immerse yourself in a virtual tour of our beautifully designed apartments today! Your perfect home awaits!",
  "property_copyright": "2026 All Rights Reserved. Juniper",
  "property_seo_title_home": "Juniper |  Apartments in Sacramento, CA",
  "property_seo_description_home": "Welcome to Juniper in Sacramento! Choose from cozy one- to four-bedroom layouts with modern amenities like a pool and dog park. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Sacramento, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal floor plan at Juniper in Sacramento! Choose from one to four bedrooms, tailored for comfort and style. Your new home awaits—browse now!",
  "property_seo_title_amenities": "Amenities | Sacramento, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Juniper in Sacramento! Enjoy amenities like a pool, dog park, and spacious floor plans. Your perfect home awaits—join our vibrant community!",
  "property_seo_title_gallery": "Gallery | Apartments in Sacramento, CA",
  "property_seo_description_gallery": "Capture the essence of home at Juniper in Sacramento! Picture your life with stunning amenities, spacious floor plans, and a vibrant community waiting for you.",
  "property_seo_title_virtualtours": "Virtual Tours | Juniper Apartments",
  "property_seo_description_virtualtours": "Experience the comforts of Juniper in Sacramento, CA! Take a virtual tour of our inviting one to four-bedroom apartments. Your ideal home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Juniper Apartments",
  "property_seo_description_interactivemap": "Welcome to Juniper in Sacramento, CA! Discover your ideal 1-4 bedroom apartment with fantastic amenities using our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Sacramento, CA",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Juniper in Sacramento. From local favorites to hidden gems, your ideal lifestyle awaits just outside your door!",
  "property_seo_title_contact": "Contact Us | Juniper",
  "property_seo_description_contact": "Connect with Juniper in Sacramento! From cozy one-bedroom to spacious four-bedroom apartments, our leasing team is ready to help. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Sacramento, CA",
  "property_seo_description_faqs": "Discover answers at Juniper in Sacramento! Explore spacious floor plans and pet-friendly amenities in our FAQs.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Sacramento, CA",
  "property_seo_description_reviews": "Join the Juniper community in Sacramento, CA! Dive into resident reviews and discover why our spacious apartments and fantastic amenities make home sweet home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Sacramento, CA",
  "property_seo_description_applynow": "Discover your ideal home at Juniper in Sacramento! Choose from 1-4 bedroom plans with modern amenities. Apply now to elevate your lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Juniper",
  "property_seo_description_residentaccess": "Experience convenience at Juniper, Sacramento! Easily manage rent, maintenance requests, and community updates through your resident portal. ",
  "property_seo_title_referafriend": "Refer A Friend | Juniper",
  "property_seo_description_referafriend": "Refer a friend to Juniper in Sacramento, CA! Great friends make for amazing neighbors. Share the joy of luxury living in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Juniper",
  "property_seo_description_scheduletour": "Discover the charm of Juniper in Sacramento! Schedule your tour today to envision life in our vibrant community with modern amenities.",
  "property_seo_title_privacy": "Privacy Policy | Juniper",
  "property_seo_description_privacy": "At Juniper in Sacramento, your privacy matters. Dive into our policy to see how we protect your data while you enjoy your vibrant new community.",
  "property_seo_title_accessibility": "Website Accessibility | Juniper",
  "property_seo_description_accessibility": "At Juniper in Sacramento, we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can enjoy a seamless online experience.",
  "property_seo_title_sitemap": "Sitemap | Juniper",
  "property_seo_description_sitemap": "Navigate your way around Juniper in Sacramento with our easy-to-use sitemap. Find your perfect apartment home and community amenities today!",
  "property_seo_title_thankyou": "Thank You | Juniper",
  "property_seo_description_thankyou": "Thank you for reaching out to Juniper in Sacramento, CA! Our team will be in touch soon to help you find your perfect new home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Sacramento, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293659103",
  "amenities": [
    {
      "id": "custom_43fab935-af31-4245-9610-89259a3588a7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Pool and Spa",
      "amount": "false",
      "description": "Appears exactly as \"the pool\" in a review; also the amenity list confirms residents mention “the pool\" – matching your title exactly.",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_19e116b7-017c-4c76-8858-5956faf68248",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Community Garden",
      "amount": "false",
      "description": "Listed in resident review verbatim as “community garden\".",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d0e4794-bff2-4615-9c39-75a561b0ac45",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "Listed in resident review verbatim as “small dog park\".",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21f9bbb0-d88c-4edf-b231-a73af320af3d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "Listed exactly as “Garbage Disposal\" under amenities.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b06ceea4-5d16-4c1f-afe2-b37e95ca1e9f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Listed exactly as “Dishwasher\" under amenities.",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b7442b3-12a1-46c9-84ba-b34ea78aa643",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "Listed exactly as “Ceiling Fans\" under amenities.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_139064ed-5520-45f2-bd19-42522a843415",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Washer Dryer In Unit*",
      "amount": "false",
      "description": "Listed exactly as “Washer Dryer In Unit\" under amenities.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5e3816f-01ae-4af8-85a1-43d18153909a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Walk In Closets*",
      "amount": "false",
      "description": "Listed exactly as “Walk In Closets\" under amenities.",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cbad83cd-e37e-41af-afdd-ac184d69964b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Short‑term leases available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47479578-cb92-46cf-b623-5166caba2141",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Near public transportation",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_240eb4a1-9dca-47ad-9c47-618c42f55aad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site management and maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d53ac705-fe41-4ca5-bb74-bfbc6deebe96",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Close to shopping, dining, colleges, and nightlife",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9fdba728-42d8-4a9d-a4d1-66f0d296e194",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "24 hr Emergency Maintenance Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92c37715-ecf1-4996-b1c4-e90f8ef9b408",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d578d972-b270-457c-9690-e9b23321121a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Large Jacuzzi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa643cfa-4e2c-4f43-8266-c1afc7942876",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Covered parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc84c57b-cb70-45f1-b3dc-801a92f10008",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "24 hour laundry facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e6ccfa00-72dc-401e-8ffc-f5891b58bf01",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Package receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd5ed476-94e5-4f86-a0dd-a6a853d26d54",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Covered parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6e35253-0909-492e-817b-d493e047818f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7bbb7791-1ec0-43a8-9f1f-a3210414e7e8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor BBQ Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_733171b8-eb0e-4fcf-81ff-d7ceb36f9ebe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Dog/Cat Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_68a3fd99-60a6-43de-8276-b9da977e869e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Kitchens",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff0e6320-eea7-4ec8-8dc2-11625d3de2cc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Central Heat and A/C",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50fea8ee-3754-4634-a15c-9a6c93ee2691",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd94316f-04a7-4249-842d-e717019d8360",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Dual pane windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_26b8f794-dbb1-4c2e-844c-0c3f5b07c678",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Extra storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1388fb5-7e26-4d7e-bef1-fb5e1ad36417",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "external_id": "false",
      "title": "Window coverings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_fcbfb7e5-6623-4f11-88dd-2e3bc5060e9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-8244-7625-8926-bdcae1e82023.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019fa3fe-8244-7625-8926-bdcae1e82023",
        "storage_key": "property/6767906449166809/019fa3fe-8244-7625-8926-bdcae1e82023.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and ample shade under blue umbrellas. Your perfect oasis awaits.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_590da125-e80e-4a9e-8568-398b70d4a576",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-9b1a-73bf-a134-0b1f2a48f1ad.webp",
      "image_media": {
        "alt_text": "Outdoor community pool area with blue lounge chairs, umbrellas, and a surrounding fence at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-9b1a-73bf-a134-0b1f2a48f1ad",
        "storage_key": "property/6767906449166809/019d20b7-9b1a-73bf-a134-0b1f2a48f1ad.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Outdoor pool at a multifamily community, featuring blue lounge chairs, umbrellas, and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor community pool area with blue lounge chairs, umbrellas, and a surrounding fence at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eFcn-riVwPhaVgSKd-5Jfk72YiVFn2q9cMfctTEVmnI/116/image.jpg"
    },
    {
      "id": "custom_7fe8cdf7-a83a-48bf-b9ac-4716dbd503d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-c855-73cb-af46-43b1e7449bf3.webp",
      "image_media": {
        "alt_text": "Outdoor apartment community pool with deck, lounge chairs, and a small pool house at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-c855-73cb-af46-43b1e7449bf3",
        "storage_key": "property/6767906449166809/019d20b7-c855-73cb-af46-43b1e7449bf3.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Outdoor pool and sun deck at a multifamily community.",
      "link": "",
      "alt_text": "Outdoor apartment community pool with deck, lounge chairs, and a small pool house at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/LthCTVROOlWiLYCfUho4hW4Khawx6OmD6icJp3ebXB8/116/image.jpg"
    },
    {
      "id": "custom_4a55c675-884b-447b-a810-c72e680ac615",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-981b-769c-a0cf-a44a6c633e7b.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor swimming pool and hot tub with lounge chairs and umbrellas.",
        "public_id": "019fa3fe-981b-769c-a0cf-a44a6c633e7b",
        "storage_key": "property/6767906449166809/019fa3fe-981b-769c-a0cf-a44a6c633e7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool or soak in the hot tub at this beautiful apartment community. Lounge chairs and umbrellas provide the perfect spot to soak up the sun.",
      "link": "",
      "alt_text": "Apartment complex outdoor swimming pool and hot tub with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90bfe766-d5f5-4e91-a986-b7bad92d62d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-b30a-774f-9528-c7a4ea447015.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at dusk.",
        "public_id": "019fa3fe-b30a-774f-9528-c7a4ea447015",
        "storage_key": "property/6767906449166809/019fa3fe-b30a-774f-9528-c7a4ea447015.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and umbrellas, perfect for soaking up the sun or enjoying a cool evening breeze.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6f4e9da-0952-49f0-b1ba-7452cdf4731d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa477-edb2-749f-9742-859781f37170.webp",
      "image_media": {
        "alt_text": "Two young women enjoying a summer day swimming in the community pool.",
        "public_id": "019fa477-edb2-749f-9742-859781f37170",
        "storage_key": "property/6767906449166809/019fa477-edb2-749f-9742-859781f37170.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Lifestyle",
      "description": "Make a splash and cool off in our sparkling swimming pool. Perfect for relaxing and having fun with friends on a sunny day.",
      "link": "",
      "alt_text": "Two young women enjoying a summer day swimming in the community pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_143e0b75-9d38-4567-80aa-eb3160195895",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-bd51-720b-b9ec-8881a6b58b92.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment community pool area with lounge chairs and blue umbrellas at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-bd51-720b-b9ec-8881a6b58b92",
        "storage_key": "property/6767906449166809/019d20b7-bd51-720b-b9ec-8881a6b58b92.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Aerial view of a multifamily community featuring a large pool, hot tub, pergola, and landscaped courtyards around residential buildings.",
      "link": "",
      "alt_text": "Aerial view of an apartment community pool area with lounge chairs and blue umbrellas at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ueHcAy8BE3P0TsL3W6TEtFM6i8l7KkggCzYQfxCLAJI/116/image.jpg"
    },
    {
      "id": "custom_2dbebfd4-9f62-4081-b8f7-1243cd4e61b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b6ae-728f-9b50-afa89337fae3.webp",
      "image_media": {
        "alt_text": "Aerial view of a residential courtyard with a central pool, lounge chairs, and blue umbrellas at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-b6ae-728f-9b50-afa89337fae3",
        "storage_key": "property/6767906449166809/019d20b7-b6ae-728f-9b50-afa89337fae3.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Aerial photo showing the community pool, landscaped courtyards, and seating areas at the apartment complex.",
      "link": "",
      "alt_text": "Aerial view of a residential courtyard with a central pool, lounge chairs, and blue umbrellas at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/J8_AWkN7bDzC833Z8g9VJDb2Hc_N67vog11tpFlVIEw/116/image.jpg"
    },
    {
      "id": "custom_9390c6a9-6033-4abf-994a-bcb15ab08078",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-25c2-7695-892b-0fefc7d73273.webp",
      "image_media": {
        "alt_text": "Wooden pergola over concrete picnic tables in a landscaped apartment courtyard at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d02d2-25c2-7695-892b-0fefc7d73273",
        "storage_key": "property/6767906449166809/019d02d2-25c2-7695-892b-0fefc7d73273.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Outdoor community gathering space with a wooden pergola, concrete picnic tables, and landscaped garden beds.",
      "link": "",
      "alt_text": "Wooden pergola over concrete picnic tables in a landscaped apartment courtyard at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166809%2Fcc65f5d4ba05f9d648b19e237bdd161e.webp"
    },
    {
      "id": "custom_1f1aed27-5886-4502-9016-13d3cdf001dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-996d-73bc-8149-ca4f7c0c549a.webp",
      "image_media": {
        "alt_text": "Wooden pergola lit by string lights over an outdoor community picnic area at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-996d-73bc-8149-ca4f7c0c549a",
        "storage_key": "property/6767906449166809/019d20b7-996d-73bc-8149-ca4f7c0c549a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Outdoor community space with a lit wooden pergola, grills, and concrete picnic tables for residents.",
      "link": "",
      "alt_text": "Wooden pergola lit by string lights over an outdoor community picnic area at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/oB81VKhIaTHl3RzHXeHLMOYIvkBFbqe9FpvN4QopFB4/116/image.jpg"
    },
    {
      "id": "custom_ae1e79e7-4d65-4b7d-ae66-e84c446a49bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-f29c-760b-8b29-3a5b460deb52.webp",
      "image_media": {
        "alt_text": "Outdoor communal grilling area under a wooden pergola with string lights at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d02d2-f29c-760b-8b29-3a5b460deb52",
        "storage_key": "property/6767906449166809/019d02d2-f29c-760b-8b29-3a5b460deb52.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "An inviting outdoor community space with built-in grills, seating, and glowing string lights under a wooden pergola.",
      "link": "",
      "alt_text": "Outdoor communal grilling area under a wooden pergola with string lights at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1eltl1SdgPPX8Q677pZdg_R19z3vd7pX8pkTOtIJbn0/116/image.jpg"
    },
    {
      "id": "custom_6fcc7e26-0dd6-4fab-91ad-fe205df907ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-f87e-73ac-bca5-352e556a2327.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-unit apartment building with green lawns, hedges, and trees along a walkway at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-f87e-73ac-bca5-352e556a2327",
        "storage_key": "property/6767906449166809/019d20b7-f87e-73ac-bca5-352e556a2327.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior view of a well-maintained apartment community with manicured lawns and landscaping.",
      "link": "",
      "alt_text": "Exterior view of a multi-unit apartment building with green lawns, hedges, and trees along a walkway at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/F4hSHeplk9NLM4zJQVjODViZZN69rtmw8kIdHBhmD_o/116/image.jpg"
    },
    {
      "id": "custom_437fc05a-d4ba-4697-a843-8336b322b6a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b81f-706a-aa48-39647272905b.webp",
      "image_media": {
        "alt_text": "Exterior view of a beige apartment building with balconies and surrounding trees at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-b81f-706a-aa48-39647272905b",
        "storage_key": "property/6767906449166809/019d20b7-b81f-706a-aa48-39647272905b.webp",
        "width": 2048,
        "height": 1364
      },
      "title": "Community",
      "description": "Exterior view of a beige apartment community with balconies, manicured landscaping, and a bright blue sky.",
      "link": "",
      "alt_text": "Exterior view of a beige apartment building with balconies and surrounding trees at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Y6NbIQmzwLAlXRGyuVzjR0SGZYplhLlT65Hvx07u2LM/116/image.jpg"
    },
    {
      "id": "custom_5c843b50-c609-4d14-b9d4-5c2e83479394",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-99a4-72e9-8eb9-ee471ff64fd2.webp",
      "image_media": {
        "alt_text": "Leasing office building entrance with landscaping.",
        "public_id": "019fa3fe-99a4-72e9-8eb9-ee471ff64fd2",
        "storage_key": "property/6767906449166809/019fa3fe-99a4-72e9-8eb9-ee471ff64fd2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing office, where our friendly staff is ready to assist you. Explore our beautiful community and find your new home.",
      "link": "",
      "alt_text": "Leasing office building entrance with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a82b21ef-9d5b-4b40-9661-963418f7e431",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-6cf3-70ec-ac99-55685d488bf6.webp",
      "image_media": {
        "alt_text": "Juniper Apartments Amazon Hub locker with a backdrop of the Tower Bridge in Sacramento, California.",
        "public_id": "019fa3fe-6cf3-70ec-ac99-55685d488bf6",
        "storage_key": "property/6767906449166809/019fa3fe-6cf3-70ec-ac99-55685d488bf6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure and convenient Amazon Hub package lockers available for residents at Juniper Apartments. Features a beautiful custom wrap showcasing the iconic Tower Bridge.",
      "link": "",
      "alt_text": "Juniper Apartments Amazon Hub locker with a backdrop of the Tower Bridge in Sacramento, California.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13c17ced-3a41-49ed-a939-97b627611dae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-7ceb-71dd-be83-b7ffb735c4be.webp",
      "image_media": {
        "alt_text": "Juniper Apartments entrance with secure gate and Amazon Hub lockers.",
        "public_id": "019fa3fe-7ceb-71dd-be83-b7ffb735c4be",
        "storage_key": "property/6767906449166809/019fa3fe-7ceb-71dd-be83-b7ffb735c4be.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure entry to Juniper Apartments featuring an Amazon Hub locker system and lush landscaping.",
      "link": "",
      "alt_text": "Juniper Apartments entrance with secure gate and Amazon Hub lockers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6edcd302-5bd4-4757-bcd9-6393c498fad3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-8484-741a-984b-4cade8826a2e.webp",
      "image_media": {
        "alt_text": "Dog park sign with a beagle holding a ball and Juniper Apartments logo.",
        "public_id": "019fa3fe-8484-741a-984b-4cade8826a2e",
        "storage_key": "property/6767906449166809/019fa3fe-8484-741a-984b-4cade8826a2e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park sign with a beagle holding a ball and Juniper Apartments logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ca92327d-f1dc-4909-a890-da0ef8984ffa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-7ace-77ef-a47c-adcd8b2d1dd0.webp",
      "image_media": {
        "alt_text": "Leasing office entrance with landscaping and red maple tree.",
        "public_id": "019fa3fe-7ace-77ef-a47c-adcd8b2d1dd0",
        "storage_key": "property/6767906449166809/019fa3fe-7ace-77ef-a47c-adcd8b2d1dd0.webp",
        "width": 3072,
        "height": 2742
      },
      "title": "Community",
      "description": "Welcome to our leasing office, where our friendly team is ready to assist you in finding your perfect home. Enjoy the beautiful landscaping and vibrant surroundings.",
      "link": "",
      "alt_text": "Leasing office entrance with landscaping and red maple tree.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4429b61f-84fe-47b9-a627-0a29654aa833",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3fe-9246-7334-a6e5-0d502c9c9b43.webp",
      "image_media": {
        "alt_text": "Juniper Apartments monument sign with address 9190 and arrow pointing to Leasing Office.",
        "public_id": "019fa3fe-9246-7334-a6e5-0d502c9c9b43",
        "storage_key": "property/6767906449166809/019fa3fe-9246-7334-a6e5-0d502c9c9b43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Juniper Apartments! Find our leasing office at 9190 with this prominent monument sign, beautifully landscaped with vibrant flowers.",
      "link": "",
      "alt_text": "Juniper Apartments monument sign with address 9190 and arrow pointing to Leasing Office.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd72dabb-eab2-4298-b111-6481382174d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-d493-74e9-9fd3-0c8425c550f8.webp",
      "image_media": {
        "alt_text": "White modern kitchen with white cabinets, gray countertops, and stainless steel fridge, dishwasher, and stove under a window at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-d493-74e9-9fd3-0c8425c550f8",
        "storage_key": "property/6767906449166809/019d20b7-d493-74e9-9fd3-0c8425c550f8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen featuring white cabinetry, gray countertops, and a full set of stainless steel appliances.",
      "link": "",
      "alt_text": "White modern kitchen with white cabinets, gray countertops, and stainless steel fridge, dishwasher, and stove under a window at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uZq3c8JmtWB1EPo6b4t0Qccq-ElWlkcyIdLDeJ2CSiU/116/image.jpg"
    },
    {
      "id": "custom_0460baef-96bd-42b2-ac4b-bb47b6c0f60f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-8f91-7358-9be6-792a3ac2b3de.webp",
      "image_media": {
        "alt_text": "Kitchen in a modern apartment with white cabinets, stainless steel appliances, and gray countertops at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-8f91-7358-9be6-792a3ac2b3de",
        "storage_key": "property/6767906449166809/019d20b7-8f91-7358-9be6-792a3ac2b3de.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright galley kitchen with stainless appliances, white cabinetry, and gray countertops.",
      "link": "",
      "alt_text": "Kitchen in a modern apartment with white cabinets, stainless steel appliances, and gray countertops at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8Q63wRklYfsEuyvXlljpnr1bOq8zLn6ICKN3JUjPeZE/116/image.jpg"
    },
    {
      "id": "custom_ed3f76a5-0aee-4c1a-b228-047e561d2ad3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-8e54-72b8-bf30-0d94265f7ec8.webp",
      "image_media": {
        "alt_text": "Unfurnished living room with white walls, gray wood-look flooring, and a ceiling fan.",
        "public_id": "019d20b7-8e54-72b8-bf30-0d94265f7ec8",
        "storage_key": "property/6767906449166809/019d20b7-8e54-72b8-bf30-0d94265f7ec8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright unfurnished living area in a modern apartment with neutral walls and laminate-like flooring.",
      "link": "",
      "alt_text": "Unfurnished living room with white walls, gray wood-look flooring, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5Ifx3O0kqAX-eZOu2d7weVNxKnpUR2g67N71oHBqWiM/116/image.jpg"
    },
    {
      "id": "custom_540d1e10-3719-44ca-abd4-b8780a7b525c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-8e96-705a-b328-301c07e7d186.webp",
      "image_media": {
        "alt_text": "Living area with neutral walls, wood-style flooring, ceiling fan, and a staircase to the upper level at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-8e96-705a-b328-301c07e7d186",
        "storage_key": "property/6767906449166809/019d20b7-8e96-705a-b328-301c07e7d186.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Interior view of a modern apartment living space featuring a staircase, neutral paint, and warm wood-toned floors.",
      "link": "",
      "alt_text": "Living area with neutral walls, wood-style flooring, ceiling fan, and a staircase to the upper level at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qPiEnHsmLo8IvmDbGtERo2247KpfweuhNL6aeHNPf2I/116/image.jpg"
    },
    {
      "id": "custom_b5f3dbd6-5849-48ea-a000-0284f05e96d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-b600-712a-8e1d-df7af38c826b.webp",
      "image_media": {
        "alt_text": "Empty bedroom with window, blinds, and a closet with sliding doors at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-b600-712a-8e1d-df7af38c826b",
        "storage_key": "property/6767906449166809/019d20b7-b600-712a-8e1d-df7af38c826b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright, empty bedroom in a neutral-toned apartment with a window, blinds, carpet, and a sliding-door closet.",
      "link": "",
      "alt_text": "Empty bedroom with window, blinds, and a closet with sliding doors at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hjJ1x7Ksza2RRE_VRcBDh7owKY5CGIJyLJXbJEfixHM/116/image.jpg"
    },
    {
      "id": "custom_5597b0d9-43e7-4828-8220-c2474b69a0eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-a864-705a-9526-093c460e3f13.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a tub/shower, toilet, and gray vanity counter at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-a864-705a-9526-093c460e3f13",
        "storage_key": "property/6767906449166809/019d20b7-a864-705a-9526-093c460e3f13.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Interior apartment bathroom with a gray vanity countertop, white sink, mirror, and tub/shower combo.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a tub/shower, toilet, and gray vanity counter at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/YaYYudFgYxqtN3MNNUtM2p1BG5ZijcrV3kADd2ucn9c/116/image.jpg"
    },
    {
      "id": "custom_ef2a5a97-e8ec-4d6c-a498-2b1bdda0b1a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-17b7-74b8-8ede-7be69763d934.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirrors, and built-in storage in an apartment at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d02d2-17b7-74b8-8ede-7be69763d934",
        "storage_key": "property/6767906449166809/019d02d2-17b7-74b8-8ede-7be69763d934.webp",
        "width": 2647,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a white vanity, sink, mirror, and nearby shelving.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirrors, and built-in storage in an apartment at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5742705921490944%2F6767906449166809%2F6576a968ca32de22843179495cfbca04.webp"
    },
    {
      "id": "custom_d15855b5-aa13-4a95-95d6-548aac791484",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d20b7-8f8f-757d-88dc-1b9c5c0d1a41.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a laundry closet next to the bathroom vanity at Juniper Apartments in Sacramento, CA.",
        "public_id": "019d20b7-8f8f-757d-88dc-1b9c5c0d1a41",
        "storage_key": "property/6767906449166809/019d20b7-8f8f-757d-88dc-1b9c5c0d1a41.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Interior of a modern apartment showing a stacked washer/dryer in a closet, beside the bathroom vanity and entry hall.",
      "link": "",
      "alt_text": "Stacked washer and dryer in a laundry closet next to the bathroom vanity at Juniper Apartments in Sacramento, CA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/jFpgExJr2A_zZ46AR96oZArrYLr23yDaGIRinmMajJo/116/image.jpg"
    },
    {
      "id": "custom_72412240-9cf0-4601-a2e6-fa3070d97bd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa411-8f04-765c-a1d9-18f7dd6775fa.webp",
      "image_media": {
        "alt_text": "Woman kissing a cat while sitting on a bed.",
        "public_id": "019fa411-8f04-765c-a1d9-18f7dd6775fa",
        "storage_key": "property/6767906449166809/019fa411-8f04-765c-a1d9-18f7dd6775fa.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Lifestyle",
      "description": "A woman with curly hair kisses a tabby cat while they sit together on a bed.",
      "link": "",
      "alt_text": "Woman kissing a cat while sitting on a bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_24b99f3c-9f77-4e68-91fe-f10b0caa195d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2001 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers and fries. They highlight the fresh ingredients, flavorful food, and affordable prices. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-a85b-7219-9249-df0c5168addf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a85b-7219-9249-df0c5168addf",
        "storage_key": "property/6767906449166809/019d02d1-a85b-7219-9249-df0c5168addf.webp",
        "width": 1102,
        "height": 1280
      },
      "poi_business_url": "https://locations.in-n-out.com/276",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866440018724358803&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.5980167",
      "poi_longitude": "-121.4194193",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-feeb-7018-a880-e737ec504ddb",
        "storage_key": "property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ6ToLSPamoARk4rP3GkRiUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_9ed3f422-9fe2-428e-b6cd-235303ec3211",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2101 Alta Arden Expy, Sacramento, CA 95825, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches, shakes, and lemonade. They also highlight the friendly and efficient service, and the fresh, tender chicken.\n\nOther reviews mention orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-4259-71cf-8f61-164a8c3e7de9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4259-71cf-8f61-164a8c3e7de9",
        "storage_key": "property/6767906449166809/019d02d2-4259-71cf-8f61-164a8c3e7de9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/arden-fair?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=15156801471129607094&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "38.5987882",
      "poi_longitude": "-121.4174906",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-922-2814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-feeb-7018-a880-e737ec504ddb",
        "storage_key": "property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Sz6ViPamoARtlvMQaLGV9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f6c74435-0784-4213-8a97-0ca29a414e0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1771 Arden Wy, Sacramento, CA 95815, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious steaks, cheesecake, and pasta. They also highlight the generous portions, extensive menu, and friendly staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/sacramento-78.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=2419075354009387255&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.5981168",
      "poi_longitude": "-121.4226717",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-567-0606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-feeb-7018-a880-e737ec504ddb",
        "storage_key": "property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-BgeRjamoAR98ChuDdIkiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_17fdbd64-fada-43db-808e-45da54a106b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Oz Korean BBQ - Sacramento",
      "poi_type": "Restaurants",
      "poi_address": "3343 Bradshaw Rd, Sacramento, CA 95827, USA",
      "poi_short_description": "Relaxed eatery featuring all-you-can-eat BBQ and other Korean grilling specialties.",
      "poi_long_description": "People say this Korean barbecue restaurant offers all-you-can-eat bulgogi and other meats, which diners cook themselves on inset table grills. They highlight the competitive pricing, fun atmosphere with a robot server, and the variety of tasty side dishes. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-a85b-7219-9249-db0b6e0e507c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-a85b-7219-9249-db0b6e0e507c",
        "storage_key": "property/6767906449166809/019d02d1-a85b-7219-9249-db0b6e0e507c.webp",
        "width": 1280,
        "height": 833
      },
      "poi_business_url": "http://ozkoreanbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2578335994149626992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oz-korean-bbq---sacramento",
      "poi_latitude": "38.5635475",
      "poi_longitude": "-121.3355409",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 916-362-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-feeb-7018-a880-e737ec504ddb",
        "storage_key": "property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xxhHbfcmoARcGTkEu0WyCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_405ad419-1e20-475f-9bb2-bd44aa564b8c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1500 Arden Wy, Sacramento, CA 95815, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Some diners say this fast food restaurant serves up delicious chicken fingers, Texas toast, and Cane's sauce, and they appreciate the friendly staff and clean dining area.\n\nOther reviews mention the drive-thru can be slow and disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-44cb-72cc-b8cf-e0f4244cc8f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-44cb-72cc-b8cf-e0f4244cc8f9",
        "storage_key": "property/6767906449166809/019d02d2-44cb-72cc-b8cf-e0f4244cc8f9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/sacramento/1500-arden-way",
      "poi_directions_map_url": "https://maps.google.com/?cid=12517647061846587894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.6007683",
      "poi_longitude": "-121.4307326",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 209-307-9964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-feeb-7018-a880-e737ec504ddb",
        "storage_key": "property/6767906449166809/019d02d1-feeb-7018-a880-e737ec504ddb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZJeoi3bmoAR9vkTca6dt60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_82692f21-2dce-4ee2-9392-5a93d52f4e0c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Arden Fair",
      "poi_type": "Shopping & Retail",
      "poi_address": "1689 Arden Wy, Sacramento, CA 95815, USA",
      "poi_short_description": "Bright, spacious mall featuring 150+ shops, a food court with fast food & full-service restaurants.",
      "poi_long_description": "People say this shopping center offers a good mix of stores, including popular brands and anchor stores, and a decent food court with standard choices and standalone restaurants. They also highlight the clean, well-lit, and safe atmosphere, as well as the free and manageable parking.\n\nOther reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-af26-77de-a99f-633662a48009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-af26-77de-a99f-633662a48009",
        "storage_key": "property/6767906449166809/019d02d1-af26-77de-a99f-633662a48009.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ardenfair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15499193860254925598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arden-fair",
      "poi_latitude": "38.6011646",
      "poi_longitude": "-121.4276086",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-920-1167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-fee2-765d-b728-bb294ce54b5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-fee2-765d-b728-bb294ce54b5a",
        "storage_key": "property/6767906449166809/019d02d1-fee2-765d-b728-bb294ce54b5a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLwm9mh7amoARHgNpmbIyGNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4ae63870-0c5c-4ffb-8dd6-87bde612099a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "KP International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10971 Olson Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Large grocery with a food court selling a wide selection of international products.",
      "poi_long_description": "People say this grocery store offers a wide variety of international foods, including fresh produce, meats, and seafood. They also highlight the reasonable prices, the fun and exciting atmosphere, and the helpful staff.\n\nOther reviews mention the food court can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-afed-70c9-8a0f-60998155ff1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-afed-70c9-8a0f-60998155ff1a",
        "storage_key": "property/6767906449166809/019d02d1-afed-70c9-8a0f-60998155ff1a.webp",
        "width": 754,
        "height": 378
      },
      "poi_business_url": "https://sac.kpmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15187449826825008127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kp-international-market",
      "poi_latitude": "38.596949",
      "poi_longitude": "-121.2834325",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-853-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-fee5-7629-ad85-8cb15a38100b",
        "storage_key": "property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ53wh7GzdmoAR__P4oyapxNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6bf6c6c8-ef82-4f88-b569-667200c28013",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Folsom Blvd, Sacramento, CA 95819, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of healthy and unique products, including delicious frozen meals, fresh produce, and affordable wines, with many praising the fresh flowers. They also highlight the friendly and helpful staff, and the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-b065-760b-8fdb-d409ad9b2b89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b065-760b-8fdb-d409ad9b2b89",
        "storage_key": "property/6767906449166809/019d02d1-b065-760b-8fdb-d409ad9b2b89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/sacramento/175/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5778462611759847179&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.5603947",
      "poi_longitude": "-121.4448167",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-456-1853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-fee5-7629-ad85-8cb15a38100b",
        "storage_key": "property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRh5PYDamoARC1fSOSE5MVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7d87ac54-44dc-4d56-860d-bd921ff1fc48",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4315 Arden Wy, Sacramento, CA 95864, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this coffee shop offers fresh produce, organic food, and a variety of grocery items, including a coffee bar and pizza. They also highlight the friendly and helpful staff, and the convenient Amazon drop-off area.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-b763-73d9-9533-ec2493cb1d9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b763-73d9-9533-ec2493cb1d9d",
        "storage_key": "property/6767906449166809/019d02d1-b763-73d9-9533-ec2493cb1d9d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/sacramento?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6874909360727790268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.5966181",
      "poi_longitude": "-121.363738",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-488-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-fee5-7629-ad85-8cb15a38100b",
        "storage_key": "property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2XZlY_bmoARvBIwhaOVaF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_64bec3fe-0b79-4355-bf90-34f4963c8a82",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2300 Watt Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this grocery store offers a wide selection of goods, including produce, meat, and bulk items. They also highlight the great prices and friendly, helpful staff.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-b76a-777b-9abb-4936e9071098.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-b76a-777b-9abb-4936e9071098",
        "storage_key": "property/6767906449166809/019d02d1-b76a-777b-9abb-4936e9071098.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12825324731443177216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.6073105",
      "poi_longitude": "-121.3817608",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-246-5370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-fee5-7629-ad85-8cb15a38100b",
        "storage_key": "property/6767906449166809/019d02d1-fee5-7629-ad85-8cb15a38100b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl8X1bMPbmoARAOezSuS0_LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_da876f5c-d611-49e0-a15d-28ed7dd87aba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "California State University, Sacramento",
      "poi_type": "Education",
      "poi_address": "6000 Jed Smith Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-49b3-71fc-94b9-b1aa646143ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-49b3-71fc-94b9-b1aa646143ef",
        "storage_key": "property/6767906449166809/019d02d2-49b3-71fc-94b9-b1aa646143ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://csus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8520208179546512258&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-university-sacramento",
      "poi_latitude": "38.560824",
      "poi_longitude": "-121.423993",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-278-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-fee2-765d-b728-bde8764beff8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-fee2-765d-b728-bde8764beff8",
        "storage_key": "property/6767906449166809/019d02d1-fee2-765d-b728-bde8764beff8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_TGMY3amoARgls_gjLcPXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cdc48dc9-1479-4727-9f83-0fd3f665bce3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "California State University, Sacramento - University Library",
      "poi_type": "Education",
      "poi_address": "2000 State University Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "University library stocking 1.4 million volumes of books, literature and films, as well as computers and charging stations.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-4a3c-725f-a2c5-a25358116df8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4a3c-725f-a2c5-a25358116df8",
        "storage_key": "property/6767906449166809/019d02d2-4a3c-725f-a2c5-a25358116df8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://library.csus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4601398765764040304&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-state-university-sacramento---university-library",
      "poi_latitude": "38.5595419",
      "poi_longitude": "-121.4236427",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-278-5679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bd-7210-92e1-5c054a7bf8b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bd-7210-92e1-5c054a7bf8b3",
        "storage_key": "property/6767906449166809/019d02d2-05bd-7210-92e1-5c054a7bf8b3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn12DOI3amoARcFZJV8xz2z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_1d8c3e87-b20a-416d-b834-b00bcd732be8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "1700 Arden Wy, Sacramento, CA 95815, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Visitors say this amusement park offers a wide variety of activities, including trampolines, a ninja course, a zip line, laser tag, rock climbing, and mini go-karts, and they praise the fun, active experience for kids and adults alike. They also highlight the friendly staff and the great value of the platinum membership, which includes a free slice of pizza and water with every visit.\n\nSome reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-bfce-74fd-bb9b-d5e18b94d3b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-bfce-74fd-bb9b-d5e18b94d3b2",
        "storage_key": "property/6767906449166809/019d02d1-bfce-74fd-bb9b-d5e18b94d3b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/california-sacramento/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9285525592382517077&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "38.5979723",
      "poi_longitude": "-121.4270554",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-930-6822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaqqNArbmoARVS_CVlTQ3IA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1646309c-b39f-4b9d-b253-27f45bc26550",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Heart Health Park",
      "poi_type": "Entertainment",
      "poi_address": "1600 Exposition Blvd, Sacramento, CA 95815, USA",
      "poi_short_description": "11,500-seat soccer stadium home to Sacramento Republic FC & hosting occasional concerts.",
      "poi_long_description": "People say this stadium offers a great venue and show. They also highlight the fun atmosphere, good food choices, and ample parking.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-4b95-7398-9295-6308573a8e2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4b95-7398-9295-6308573a8e2c",
        "storage_key": "property/6767906449166809/019d02d2-4b95-7398-9295-6308573a8e2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1684135755716371847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "heart-health-park",
      "poi_latitude": "38.5913553",
      "poi_longitude": "-121.4380313",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05db-7454-b069-21f3ad1eec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05db-7454-b069-21f3ad1eec02",
        "storage_key": "property/6767906449166809/019d02d2-05db-7454-b069-21f3ad1eec02.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN4Sjiw_amoARhyUCAYxAXxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_52403003-0007-4ea5-96da-3670e5c76407",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Sacramento Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "2701 Prospect Park Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Open since 2011, a museum for kids aged 8 and under which runs interactive events & activities.",
      "poi_long_description": "People say this children's museum offers a variety of interactive exhibits, play areas, and activities, including a little house, grocery store, and rooms for coloring and painting. They also highlight the fun, engaging, and educational experience, and the friendly, helpful, and attentive staff.\n\nOther reviews mention it can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-bfb9-720d-8464-35a327935696.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-bfb9-720d-8464-35a327935696",
        "storage_key": "property/6767906449166809/019d02d1-bfb9-720d-8464-35a327935696.webp",
        "width": 1280,
        "height": 984
      },
      "poi_business_url": "http://www.sackids.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15104424772155538293&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-childrens-museum",
      "poi_latitude": "38.5888889",
      "poi_longitude": "-121.2838889",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-730-5079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05c0-725a-ad6a-4f8a35709d8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05c0-725a-ad6a-4f8a35709d8b",
        "storage_key": "property/6767906449166809/019d02d2-05c0-725a-ad6a-4f8a35709d8b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WM0IQPamoARdfvwuE2yndE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9ed073f3-8f6e-4672-9e61-bc39ed764404",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Hornet Stadium",
      "poi_type": "Entertainment",
      "poi_address": "6000 Jed Smith Dr, Sacramento, CA 95819, USA",
      "poi_short_description": "Named for State's football team, this modern 21,000 seat venue is also home to track & field events.",
      "poi_long_description": "People say this stadium offers exciting games and live performances. They highlight the fun atmosphere and the team's hard work. They also like the expansion and the potential for future growth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-4e50-76cb-9a03-79ceb3691c6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-4e50-76cb-9a03-79ceb3691c6c",
        "storage_key": "property/6767906449166809/019d02d2-4e50-76cb-9a03-79ceb3691c6c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://hornetsports.com/facilities/hornet-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=738777546652676940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hornet-stadium",
      "poi_latitude": "38.5557157",
      "poi_longitude": "-121.4229836",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-278-6011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05db-7454-b069-21f3ad1eec02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05db-7454-b069-21f3ad1eec02",
        "storage_key": "property/6767906449166809/019d02d2-05db-7454-b069-21f3ad1eec02.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhUoLWIramoARTHNEtEOqQAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_93e92653-0327-434f-9273-2d630726f151",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Rebounderz Sacramento - Indoor Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2401 Butano Dr, Sacramento, CA 95825, USA",
      "poi_short_description": "Trampoline park with climbing walls, arcade games and a ninja course, plus free WiFi.",
      "poi_long_description": "People say this amusement park offers a variety of play areas, structures, and video games, as well as an arcade with prizes. They also highlight the friendly and attentive staff, and the positive and fun vibe.\n\nSome reviews mention there can be safety hazards.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-c78f-77cb-8e4f-0bc796dc8b2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c78f-77cb-8e4f-0bc796dc8b2d",
        "storage_key": "property/6767906449166809/019d02d1-c78f-77cb-8e4f-0bc796dc8b2d.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.rebounderz.com/city/sacramento/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13746415684359926292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rebounderz-sacramento---indoor-trampoline-and-adventure-park",
      "poi_latitude": "38.6078872",
      "poi_longitude": "-121.3804779",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-829-8969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadAv-MXbmoARFLIhuTsUxb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_7eb19f03-374a-41f2-81e6-1721a1d81ccd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "VCA Sacramento Veterinary Referral Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9801 Old Winery Pl, Sacramento, CA 95827, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-c910-719c-ae84-5408ebdab82a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-c910-719c-ae84-5408ebdab82a",
        "storage_key": "property/6767906449166809/019d02d1-c910-719c-ae84-5408ebdab82a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://vcahospitals.com/sacramento-veterinary-referral-center?utm_source=maps&utm_medium=organic&utm_campaign=AU_595",
      "poi_directions_map_url": "https://maps.google.com/?cid=15938789651328108313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-sacramento-veterinary-referral-center",
      "poi_latitude": "38.574361",
      "poi_longitude": "-121.331015",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-362-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwLOfcDcmoARGYcVlb30Md0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f8bd3d67-11b3-4099-91f4-1074cce2aa06",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2400 Watt Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "Health-and-fitness chain offering equipment, 30-minute circuit classes and tanning in an inclusive zone.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-5325-73fe-b5b5-78d602e106c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-5325-73fe-b5b5-78d602e106c3",
        "storage_key": "property/6767906449166809/019d02d2-5325-73fe-b5b5-78d602e106c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/sacramento-country-club-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11120778406635775460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.6082699",
      "poi_longitude": "-121.381441",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-407-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYzIGVdvbmoAR5CVcWQrxVJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_94592292-e25e-44e2-9a99-06981a8a4d5a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "The WELL",
      "poi_type": "Health and Wellness",
      "poi_address": "6000 J St, Sacramento, CA 95819, USA",
      "poi_short_description": "Modern, spacious, on-campus gym featuring weight machines, classes, basketball and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-ceaf-763b-84d2-2a182b2df62c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-ceaf-763b-84d2-2a182b2df62c",
        "storage_key": "property/6767906449166809/019d02d1-ceaf-763b-84d2-2a182b2df62c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thewellatsacstate.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5612426490005051286&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-well",
      "poi_latitude": "38.5569669",
      "poi_longitude": "-121.4235304",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-278-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUeFxZLamoARlle-IChY400",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1eac7efb-5cce-4792-93fa-49f6aff9cf6b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Crunch Fitness - Market Square",
      "poi_type": "Health and Wellness",
      "poi_address": "1739 Arden Wy, Sacramento, CA 95815, USA",
      "poi_short_description": "Membership-only gym at Market Square at Arden Fair offering group classes and personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment, including weights and machines. They also highlight the clean and motivating environment, and the friendly and helpful staff.\n\nOther reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-55f6-7662-b579-2126f9ed51f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-55f6-7662-b579-2126f9ed51f6",
        "storage_key": "property/6767906449166809/019d02d2-55f6-7662-b579-2126f9ed51f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/marketsquare",
      "poi_directions_map_url": "https://maps.google.com/?cid=17728157417301185125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---market-square",
      "poi_latitude": "38.5994681",
      "poi_longitude": "-121.4232353",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-913-2260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZ8uG_3bmoARZZJxRD4RB_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a03c94b9-7e8d-47a1-8bb0-0a05c29f122e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6061 Florin Rd, Sacramento, CA 95823, USA",
      "poi_short_description": "Spacious fitness center with clean facilities offering cardio equipment, group classes and a sauna.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, amenities, and group classes. They also highlight the affordable prices, clean facilities, and friendly staff.\n\nSome reviews mention the hours can be inconvenient.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-5701-737b-9a30-bb797016fc6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-5701-737b-9a30-bb797016fc6d",
        "storage_key": "property/6767906449166809/019d02d2-5701-737b-9a30-bb797016fc6d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/ca/florin-rd/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2469417804062423060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "38.4991204",
      "poi_longitude": "-121.4319578",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-603-5852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_20Zq6DFmoARFHgqxWgiRSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d4fc122f-0032-407e-a846-62c553c82f80",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9574 Micron Ave, Sacramento, CA 95827, USA",
      "poi_short_description": "Chain fitness center with strength and cardio equipment, a lap pool, and personal training.",
      "poi_long_description": "People say this gym offers a variety of equipment, including cardio machines, weights, and a sauna. They also highlight the friendly and helpful staff, and the convenient location.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-5857-7451-9fdd-8ade7976cbb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-5857-7451-9fdd-8ade7976cbb8",
        "storage_key": "property/6767906449166809/019d02d2-5857-7451-9fdd-8ade7976cbb8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/sacramento-ca/rancho-cordova-active?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351542931293028536&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.562658",
      "poi_longitude": "-121.341053",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 916-363-4382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT8BMQbDcmoARuEBFbalZ7OI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fdc3ec91-b70d-4e1f-98bc-6e6f664cbf6d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1220 Arden Hills Ln, Sacramento, CA 95864, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of high-quality cardio and resistance machines, free weights, and benches, and has a beautiful sauna, steam room, and recovery section.\n\nOther reviews mention the facility can be under construction and the membership fees can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-59cb-7141-9e9e-48f92db80d92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-59cb-7141-9e9e-48f92db80d92",
        "storage_key": "property/6767906449166809/019d02d2-59cb-7141-9e9e-48f92db80d92.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/arden.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=16318376630873716585&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.5882885",
      "poi_longitude": "-121.3550755",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-604-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaMku2TbmoARaXdDWhaFduI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6f623bb0-baaa-47ca-9e36-731c82d7cbe5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "UC Davis Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4301 X St, Sacramento, CA 95817, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-d85b-756c-ab0b-afb8ff3e5d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-d85b-756c-ab0b-afb8ff3e5d5e",
        "storage_key": "property/6767906449166809/019d02d1-d85b-756c-ab0b-afb8ff3e5d5e.webp",
        "width": 500,
        "height": 330
      },
      "poi_business_url": "https://health.ucdavis.edu/medicalcenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8899362877471555770&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uc-davis-medical-center",
      "poi_latitude": "38.5547656",
      "poi_longitude": "-121.4552827",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-734-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0ad1-7070-bb72-0017c55b2229.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0ad1-7070-bb72-0017c55b2229",
        "storage_key": "property/6767906449166809/019d02d2-0ad1-7070-bb72-0017c55b2229.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4rq2nzQmoARuoD93mLjgHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9ab01985-c24a-4c9e-8ccc-71afd0161a56",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Kaiser Permanente Sacramento Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2025 Morse Ave, Sacramento, CA 95825, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://healthy.kaiserpermanente.org/northern-california/facilities/Sacramento-Medical-Center-100330",
      "poi_directions_map_url": "https://maps.google.com/?cid=825758789253687625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-sacramento-medical-center",
      "poi_latitude": "38.6021267",
      "poi_longitude": "-121.3924928",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-973-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0ad1-7070-bb72-0017c55b2229.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0ad1-7070-bb72-0017c55b2229",
        "storage_key": "property/6767906449166809/019d02d2-0ad1-7070-bb72-0017c55b2229.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ24Jpp87bmoARSWmfZz6vdQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f0347ddd-3d9e-4364-ae41-b2c026aa1c1d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "McKinley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 Alhambra Blvd, Sacramento, CA 95816, USA",
      "poi_short_description": "Relaxing preserve featuring a rose garden, seasonal pool, playgrounds, tennis courts & trails.",
      "poi_long_description": "People say this park offers a playground, rose garden, pond with ducks, tennis courts, volleyball nets, and a library. They highlight the park is relaxing, beautiful, and well-maintained, with plenty of picnic areas and benches. They also like the variety of activities available for people of all ages, including walking, jogging, and playing games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-5e7d-76bd-b8bc-e2f75aa87c77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-5e7d-76bd-b8bc-e2f75aa87c77",
        "storage_key": "property/6767906449166809/019d02d2-5e7d-76bd-b8bc-e2f75aa87c77.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofsacramento.org/ParksandRec/Parks/Park-Directory/Central-City/McKinley-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9817515343663866372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mckinley-park",
      "poi_latitude": "38.5768935",
      "poi_longitude": "-121.4630764",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-808-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0b1b-7078-9e57-95b60e4990e8",
        "storage_key": "property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb6sj4JfQmoARBCIIjDDSPog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6d34d80f-77b2-4100-bdc1-5f7aea92f8c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "River Bend Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 Rod Beaudry Dr, Sacramento, CA 95827, USA",
      "poi_short_description": "444-acre riverfront park features rafting, equestrian & hiking trails, picnicking space & wildlife.",
      "poi_long_description": "People say this park offers rafting, hiking trails, and access to the American River. They highlight the scenic views, opportunities for wildlife viewing, and the availability of picnic areas and restrooms. They also like the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-df9e-73e6-b0d5-30aeab8d31df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-df9e-73e6-b0d5-30aeab8d31df",
        "storage_key": "property/6767906449166809/019d02d1-df9e-73e6-b0d5-30aeab8d31df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.regionalparks.saccounty.net/Parks/Pages/RiverBendPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13299131916403720630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "river-bend-park",
      "poi_latitude": "38.5952521",
      "poi_longitude": "-121.3302371",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0b1b-7078-9e57-95b60e4990e8",
        "storage_key": "property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqjbDmoARtsFNIgQCkLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5a9324ad-18be-424d-b696-d0aabd885093",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Hagan Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2197 Chase Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "Large green space with lots of amenities, including athletic fields, an aquatic center & a dog park.",
      "poi_long_description": "People say this park offers playgrounds, open fields, trails, river access, and a dog park with separate areas for large and small dogs. They highlight the park is clean, safe, and spacious, with amenities like picnic tables, BBQ grills, and a miniature train. They also like the fishing opportunities and the animal barn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-5f59-775c-b6d9-15cedcbd3fc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-5f59-775c-b6d9-15cedcbd3fc8",
        "storage_key": "property/6767906449166809/019d02d2-5f59-775c-b6d9-15cedcbd3fc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://crpd.com/parks/hagan-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13509648951063243279&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hagan-community-park",
      "poi_latitude": "38.6047426",
      "poi_longitude": "-121.3103096",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 916-369-9844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0b1b-7078-9e57-95b60e4990e8",
        "storage_key": "property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97R8XFXcmoARD2pa0CTqe7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_46c4df5c-d560-453c-9dfb-18f4a0e42c1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Howe Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2201 Cottage Way, Sacramento, CA 95825, USA",
      "poi_short_description": "Green space with playgrounds & picnic tables, plus areas for softball, soccer, volleyball & tennis.",
      "poi_long_description": "Visitors say this park offers a duck pond, dog park, playgrounds, tennis courts, walking trails, and a fishing pond. They also highlight the clean bathrooms, well-maintained park, and family-friendly atmosphere with plenty of space for picnics and outdoor activities.\n\nSome reviews mention parking can be limited, especially on weekends or during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-e13b-7139-8b32-1420b86fdfe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-e13b-7139-8b32-1420b86fdfe2",
        "storage_key": "property/6767906449166809/019d02d1-e13b-7139-8b32-1420b86fdfe2.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.fecrpd.com/howe-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966806415543167145&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "howe-community-park",
      "poi_latitude": "38.6060042",
      "poi_longitude": "-121.4133259",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 916-927-3802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0b1b-7078-9e57-95b60e4990e8",
        "storage_key": "property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4a3RibamoARqegkQO1-cHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ac8c9d49-fd26-4d20-88d1-4ece913ae227",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Ancil Hoffman Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6700 Tarshes Dr, Carmichael, CA 95608, USA",
      "poi_short_description": "Noted golf course, nature center & trails featured at a riverfront preserve with ancient oak trees.",
      "poi_long_description": "People say this park offers walking trails, river access, and barbecue areas. They highlight the well-maintained grounds, beautiful views, and opportunities for picnics and parties. They also like the convenient parking and access to the Effie Yuaw Cultural Center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-6254-77f9-b2c2-ae656412d57b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-6254-77f9-b2c2-ae656412d57b",
        "storage_key": "property/6767906449166809/019d02d2-6254-77f9-b2c2-ae656412d57b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://regionalparks.saccounty.net/Parks/Pages/AncilHoffmanPark.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14936912369318475925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ancil-hoffman-park",
      "poi_latitude": "38.611886",
      "poi_longitude": "-121.310789",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-875-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0b1b-7078-9e57-95b60e4990e8",
        "storage_key": "property/6767906449166809/019d02d2-0b1b-7078-9e57-95b60e4990e8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx8Ubrk3cmoARlbhdJqmSSs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ac08b4f9-a52a-460e-a6b4-84b9bdcc42f3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Sacramento Mather Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "10425 Norden Ave, Mather, CA 95655, USA",
      "poi_short_description": "",
      "poi_long_description": "Visitors say this airport hosts an awesome air show. They also highlight the amazing performances and photo opportunities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-638d-7498-9e1e-c4857e77f385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-638d-7498-9e1e-c4857e77f385",
        "storage_key": "property/6767906449166809/019d02d2-638d-7498-9e1e-c4857e77f385.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sacramento.aero/mhr",
      "poi_directions_map_url": "https://maps.google.com/?cid=12077780130290008957&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-mather-airport",
      "poi_latitude": "38.5636592",
      "poi_longitude": "-121.297211",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-875-7077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0b1b-7078-9e57-939204c69fd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0b1b-7078-9e57-939204c69fd3",
        "storage_key": "property/6767906449166809/019d02d2-0b1b-7078-9e57-939204c69fd3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ290Y9JTCmoARfQM1pQnlnKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_529a88ad-ef25-40d0-85b9-4506df00f26a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "University/65th Street Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sacramento, CA 95819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-654e-766a-9464-104e055d9d8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-654e-766a-9464-104e055d9d8a",
        "storage_key": "property/6767906449166809/019d02d2-654e-766a-9464-104e055d9d8a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3002021551157189183&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university65th-street-station-wb",
      "poi_latitude": "38.55265",
      "poi_longitude": "-121.42749",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77gV9pPamoARP5rKBLJSqSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2fe1257d-9284-4117-b697-bfb10357e638",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "California Capital Airshow",
      "poi_type": "Transportation & Transit",
      "poi_address": "10425 Norden Ave, Mather, CA 95655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-663a-71fc-817d-366044ea682f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-663a-71fc-817d-366044ea682f",
        "storage_key": "property/6767906449166809/019d02d2-663a-71fc-817d-366044ea682f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://californiacapitalairshow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3182739494611207897&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "california-capital-airshow",
      "poi_latitude": "38.5658911",
      "poi_longitude": "-121.3012134",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-876-7568",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-0b1b-7078-9e57-939204c69fd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-0b1b-7078-9e57-939204c69fd3",
        "storage_key": "property/6767906449166809/019d02d2-0b1b-7078-9e57-939204c69fd3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDQN9PCmoAR2UboHLVcKyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_27a6c0ba-413a-4eb2-bc5e-8b3fa0547b2f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Mather Field/Mills Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-69a0-75ec-b572-2857d101144a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-69a0-75ec-b572-2857d101144a",
        "storage_key": "property/6767906449166809/019d02d2-69a0-75ec-b572-2857d101144a.webp",
        "width": 1280,
        "height": 1114
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13234103057144582232&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mather-fieldmills-station-wb",
      "poi_latitude": "38.584483",
      "poi_longitude": "-121.311617",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP4eB_uDcmoARWJAD-pz6qLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_146fed46-1eda-4966-8b92-3d4cb721d461",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Watt/Manlove Station (WB)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Rosemont, CA 95826, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-ef2f-724a-8e4f-84dbc9cd003b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef2f-724a-8e4f-84dbc9cd003b",
        "storage_key": "property/6767906449166809/019d02d1-ef2f-724a-8e4f-84dbc9cd003b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6840555224202113319&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wattmanlove-station-wb",
      "poi_latitude": "38.553684",
      "poi_longitude": "-121.373651",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXdILj0jbmoARJ3ECzbuI7l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_884fd067-89e5-4040-a9e7-ce1a51a7d6f4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Solidigm",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10951 White Rock Rd, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-efb0-739a-b4aa-a06e8a57b29c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-efb0-739a-b4aa-a06e8a57b29c",
        "storage_key": "property/6767906449166809/019d02d1-efb0-739a-b4aa-a06e8a57b29c.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.solidigm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206253238189211691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "solidigm",
      "poi_latitude": "38.5904826",
      "poi_longitude": "-121.2786463",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 855-765-4301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3C6eTLdmoARK8AKNDrC3AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_322269e9-0a6e-4949-a59e-e97a0f6b78af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Rancho Cordova City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2729 Prospect Park Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-f52b-7462-83d9-f67eec9a32a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-f52b-7462-83d9-f67eec9a32a8",
        "storage_key": "property/6767906449166809/019d02d1-f52b-7462-83d9-f67eec9a32a8.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.cityofranchocordova.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9712799136449957214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rancho-cordova-city-hall",
      "poi_latitude": "38.5892875",
      "poi_longitude": "-121.284565",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-851-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bd-7210-92e1-5c054a7bf8b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bd-7210-92e1-5c054a7bf8b3",
        "storage_key": "property/6767906449166809/019d02d2-05bd-7210-92e1-5c054a7bf8b3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfmFE0DdmoARXg3SnlrLyoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_eec9a6a7-b692-4806-afc1-c1af2d241569",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Youth Detention Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9601 Kiefer Blvd, Sacramento, CA 95827, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-f6f7-731a-9e90-3dfd75fadea9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-f6f7-731a-9e90-3dfd75fadea9",
        "storage_key": "property/6767906449166809/019d02d1-f6f7-731a-9e90-3dfd75fadea9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.saccounty.net/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3424225278182912545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "youth-detention-facility",
      "poi_latitude": "38.5464838",
      "poi_longitude": "-121.3411412",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 916-876-9301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bd-7210-92e1-5c054a7bf8b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bd-7210-92e1-5c054a7bf8b3",
        "storage_key": "property/6767906449166809/019d02d2-05bd-7210-92e1-5c054a7bf8b3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYKdmUXDmoARIXIBib9KhS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_913a69f1-12f2-4c48-a329-2d7970ef2e0b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "VSP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3333 Quality Dr, Rancho Cordova, CA 95670, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-6eac-7473-9f34-566b1cb05421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-6eac-7473-9f34-566b1cb05421",
        "storage_key": "property/6767906449166809/019d02d2-6eac-7473-9f34-566b1cb05421.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.vsp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10214769660848340697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vsp",
      "poi_latitude": "38.5837561",
      "poi_longitude": "-121.2884037",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-851-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwgV7z7dmoAR2X5N6eImwo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4e67dac9-bad4-4069-bb04-fff9b6193a88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "poi_name": "Sacramento Metropolitan Fire District Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10545 Armstrong Ave STE 200, Mather, CA 95655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d1-f84e-70cd-94b5-4c4a78eda73d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d1-f84e-70cd-94b5-4c4a78eda73d",
        "storage_key": "property/6767906449166809/019d02d1-f84e-70cd-94b5-4c4a78eda73d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://metrofire.ca.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9756846587005145379&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sacramento-metropolitan-fire-district-headquarters",
      "poi_latitude": "38.569597",
      "poi_longitude": "-121.2963098",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-859-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d2-05bf-7208-b074-82785e93fc7f",
        "storage_key": "property/6767906449166809/019d02d2-05bf-7208-b074-82785e93fc7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7dVkDLdmoARI5Fs4kZIZ4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b6097960-4172-4ee7-b797-e6a5c3d074d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_25436f3c-00cf-4015-95a1-e27698cb1085",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_9df4a444-43cb-45b2-9f27-dbbb535a105e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f0e3ab28-54cc-4cc1-8f57-d0f2f853ca2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_ec8264ef-907b-4e4a-baa4-dfed7ead6d28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e6e2aa21-ac04-4e3b-bbb0-f795a9139fe9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Cam M.",
      "text": "Amazing Place to Live!\nLiving at Juniper Apartments has been a great experience so far! The management is responsive, maintenance is quick, and the amenities—like the pool, community garden and small dog park—makes daily life enjoyable here. The buildings and grounds are well maintained, and the complex is within manageable distances from everything in the Sac area. I recommend Juniper for anyone looking for a great place to call home!",
      "date": "2025-03-17",
      "title": ""
    },
    {
      "id": "custom_a2b2b957-cf60-46f8-a1af-7d4029cd6182",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Leonardo V.",
      "text": "My experience at Juniper Apartments has been excellent so far. From the admissions office, Brie provided me with a tour and explained all the wonderful amenities. This sparked my interest in this apartments so I submitted an application; the whole application process was easy and Brie was able to get us into an amazing apartment. Once here we noticed small things that needed attention and that is when we submitted a work order with the maintenance department; Jose and another gentlemen came the next day and solved all the small issues in the unit. I would recommend this apartments to anyone that wants a peaceful environment and great amenities.",
      "date": "2026-03-31",
      "title": ""
    },
    {
      "id": "custom_f8c87f0c-9d81-4521-bf0c-79a4092373a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Emma E.",
      "text": "We love our new apartment! We are still moving stuff in, but we love Jose, Andre’s, and Brie! The whole entire staff are very kind, quick, and friendly! It’s such a quiet and peaceful property. Plenty of parking.  Walkable to 7/11 and Dutch bros. Located near a residential area and plenty of places to walk your dog. My dog loves all of the bushes and landscaping they do around the sidewalks and in the garden area.",
      "date": "2026-03-31",
      "title": ""
    },
    {
      "id": "custom_854d691e-46ea-4b8c-bc33-5346942ef2aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Angel D.",
      "text": "I had a wonderful experience working Bri the leasing agent for Juniper Apartments. From the very beginning, she was professional, friendly, and incredibly helpful. She took the time to answer all my questions, explained everything clearly, and made the entire leasing process smooth and stress-free.\n\nHer responsiveness and attention to detail really stood out, and it was clear she genuinely cared about helping me find the right place. Thanks to Bri's support, I felt confident and comfortable every step of the way. I highly recommend her to anyone looking for a positive and hassle-free apartment leasing experience!",
      "date": "2026-01-23",
      "title": ""
    },
    {
      "id": "custom_d25b008f-6a26-4435-9e72-3bf498c0f17a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Isis P.",
      "text": "Wonderful experience from the start! We just moved in back in December and have been having a great time! Bri was our leasing agent and she was amazing! I love her personality she was easy going. The staff have been very responsive and understanding, I always get a response back. I hope the rest of our time here continues to be smooth!",
      "date": "2026-01-24",
      "title": ""
    },
    {
      "id": "custom_77826fe6-f4d9-4e31-964d-744528d6034a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Mary Ann Herbert",
      "text": "Jose the maintenance worker is very helpful, friendly and conscientious. He also comes as soon as he can to address any problems.",
      "date": "2026-09-04",
      "title": ""
    },
    {
      "id": "custom_80aa29ad-be9f-496b-a5de-94a83bd85f97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "R Medrano",
      "text": "Brie is very well spoken and very professional. She is definitely in the industry she is meant to be in. She always has a positive attitude and her smile is contagious making everyone around want to smile. She gave me a tour and she made sure that I got to see exactly what I wanted. I couldn’t help but picture living myself here.",
      "date": "2026-09-03",
      "title": ""
    },
    {
      "id": "custom_a16e47ff-0baa-4419-906b-f774484f29ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Snow Ortiz",
      "text": "The Assistant Manager Brie, is very kind. She makes sure to explain everything as it is so there is no surprises. She had made looking for an apartment easier and genuinely cares about making sure people are happy.",
      "date": "2026-09-02",
      "title": ""
    },
    {
      "id": "custom_414a90e1-23c3-4b99-81a6-45e0e3c30637",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5.0",
      "name": "Meercedes Savala",
      "text": "The Manager Isabel is so wonderful and so is her assistant!! Always so nice and friendly and on top of things.",
      "date": "2026-08-04",
      "title": ""
    },
    {
      "id": "custom_175742b8-7949-4bc0-9c81-56b6d4e8da58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "4.0",
      "name": "Arthur Taylor",
      "text": "Lived here for 4 years so far, nice quiet place reasonable rent for the area. Maintenance was always particularly well done. Never had an issue that wasn't solved within a day or two. Shout out to Jose who as well as doing that, Also, does the grilling and barbecuing on community Days",
      "date": "2026-05-06",
      "title": ""
    },
    {
      "id": "custom_bf7d8918-898a-47a9-aa4b-fb82f2a9c9d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5",
      "name": "Dre Guidry II",
      "text": "This review is long over due. Been here for 5 years and the maintenance team is fabulous. Jose & Andreas kick ass.. A man of their word & always welling to go out of their way, even OFF the clock. To be honest, their the only reason I have been here for this long.. I asked Jose the other day if he can re-paint my door when ever he has the opportunity, came home from work the next day and the job was done. Thank yo",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "custom_44130186-7e66-4eb9-982e-f3c547305e2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "rating": "5",
      "name": "Isis Payton",
      "text": "Wonderful experience from the start! We just moved in back in December and have been having a great time! Bri was our leasing agent and she was amazing! I love her personality she was easy going. The staff have been very responsive and understanding, I always get a response back. I hope the rest of our time here continues to be smooth!\n",
      "date": "2026-02-04",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3c3db230-ad9a-4192-b958-99a82beef860",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019fa3e5-8d5e-7548-af24-19a28b81e18d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding amenities at a multifamily property.",
        "public_id": "019fa3e5-8d5e-7548-af24-19a28b81e18d",
        "storage_key": "property/6767906449166809/019fa3e5-8d5e-7548-af24-19a28b81e18d.webp",
        "width": 800,
        "height": 600
      },
      "virtual_tour_title": "Community Video",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/2t2o5u?source=180"
    },
    {
      "id": "custom_7781f48a-9428-4bae-8953-ee79c5b8393a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d3-37b9-70ca-bc9e-1017053c2fc7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty living room with wood floors and sliding glass door leading to balcony",
        "public_id": "019d02d3-37b9-70ca-bc9e-1017053c2fc7",
        "storage_key": "property/6767906449166809/019d02d3-37b9-70ca-bc9e-1017053c2fc7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gcr1gbNT3Pv"
    },
    {
      "id": "custom_84535265-e2b2-49fb-a119-ff0b1ade4d3e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d3-37e9-73b8-b48f-e4ceb32a87d0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an apartment showing the living area and stairs.",
        "public_id": "019d02d3-37e9-73b8-b48f-e4ceb32a87d0",
        "storage_key": "property/6767906449166809/019d02d3-37e9-73b8-b48f-e4ceb32a87d0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PjwBMQ3SaWy"
    },
    {
      "id": "custom_65e1c3ae-ec5f-4d10-80f6-1b48ad498941",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d3-37ba-727f-b01b-c592c9c66711.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty apartment living room with white walls and wood-look flooring.",
        "public_id": "019d02d3-37ba-727f-b01b-c592c9c66711",
        "storage_key": "property/6767906449166809/019d02d3-37ba-727f-b01b-c592c9c66711.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eXHwSCBrXy9"
    },
    {
      "id": "custom_7b6bc3c2-1653-4c66-ae7d-5e1f56c4fc13",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166809/019d02d3-37ba-727f-b01b-c1a96b96b986.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with black countertops, white cabinets, stainless steel sink, and black refrigerator.",
        "public_id": "019d02d3-37ba-727f-b01b-c1a96b96b986",
        "storage_key": "property/6767906449166809/019d02d3-37ba-727f-b01b-c1a96b96b986.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 639 SF Townhome",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mCdm68ocdRE"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f0488-e539-767a-928a-d4265b75235a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Juniper Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "washer-dryer-apartments-sacramento-juniper",
      "search_query": "washer dryer apartments in Sacramento",
      "category": "Amenity",
      "h1_title": "Washer Dryer Apartments in Sacramento",
      "h2_subtitle": "Discover the comfort of washer dryer apartments in Sacramento. Juniper offers convenient amenities in the Rosemont Downs area.",
      "page_copy": "Experience the ultimate convenience at Juniper, featuring modern washer dryer apartments in Sacramento. Located in the inviting Rosemont Downs neighborhood, our community provides easy access to everything you need. Each of our spacious units includes a washer/dryer hookup, making laundry day a breeze. \n\nOur well-appointed apartments offer additional amenities like large bedrooms and walk-in closets, which add to your living comfort. Relish in the tranquil environment by enjoying a swim in our pool or unwind in the unique loft layouts available. Embrace the ease of living with essential conveniences at Juniper in Sacramento County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer Dryer Apartments in Sacramento",
      "seo_description": "Find washer dryer apartments in Sacramento at Juniper, where each unit offers modern convenience and comfort in the Rosemont Downs area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "sacramento-county-air-conditioned-apartments-juniper",
      "search_query": "apartments with air conditioning Sacramento County",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Sacramento County",
      "h2_subtitle": "Enjoy comfortable apartment living with air conditioning in Sacramento County.",
      "page_copy": "At Juniper, enjoy comfortable apartment living with air conditioning in Sacramento County. Located in Rosemont Downs, Juniper offers thoughtfully designed homes that provide a comfortable environment during warm California days.\nOur apartments feature modern conveniences, including large bedrooms, walk-in closets, washer/dryer hookups, and a refreshing pool. Unique loft layouts add a modern touch, creating a comfortable living experience in Sacramento County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioning Apartments Sacramento County",
      "seo_description": "Discover apartments with air conditioning in Sacramento County at Juniper, offering refreshing comfort alongside luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "poolside-apartments-rosemont-downs-juniper",
      "search_query": "poolside apartments near Rosemont Downs",
      "category": "Amenity",
      "h1_title": "Poolside Apartments Near Rosemont Downs",
      "h2_subtitle": "Relax at poolside apartments near Rosemont Downs. Juniper blends leisure and convenience in a friendly community.",
      "page_copy": "Juniper offers poolside apartments near Rosemont Downs, perfect for those looking to blend leisure with comfort. Our community features a stunning pool, providing an ideal retreat on those warm Sacramento days. Enjoy poolside relaxation just steps from your home.\n\nSituated in the heart of a friendly neighborhood, our apartments boast large bedrooms and walk-in closets, offering ample space and storage. Each unit is equipped with washer/dryer hookups and designed with a modern loft layout. With the convenience and luxury offered at Juniper, you'll find the perfect balance of home comfort and community vibe nearby.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Apartments Near Rosemont Downs",
      "seo_description": "Find your dream poolside apartment near Rosemont Downs at Juniper, where relaxation and modern amenities converge in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-dog-park-sacramento-juniper",
      "search_query": "pet-friendly apartments with dog park in Sacramento",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park in Sacramento",
      "h2_subtitle": "Live in pet-friendly apartments with a dog park in Sacramento. Juniper welcomes you and your furry friends to a vibrant community.",
      "page_copy": "Discover pet-friendly apartments at Juniper in Sacramento, featuring convenient amenities and spaces designed with pets in mind. Enjoy access to nearby areas for walks and outdoor activities while living in a community that welcomes both residents and their pets.\nLocated in Rosemont Downs, Juniper offers spacious apartments with large bedrooms, walk-in closets, washer/dryer hookups, and unique loft layouts. Experience comfortable pet-friendly living with modern features and convenient access to Sacramento amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park Sacramento",
      "seo_description": "Discover pet-friendly apartments with a dog park in Sacramento at Juniper. Enjoy a vibrant community perfect for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "gated-community-apartments-dishwasher-95826-juniper",
      "search_query": "gated community apartments with dishwasher 95826",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments with Dishwasher in 95826",
      "h2_subtitle": "Discover comfort in gated community apartments with dishwashers in 95826. Juniper offers a secure, amenity-rich lifestyle.",
      "page_copy": "Located in the heart of the 95826 area, Juniper offers gated community apartments with dishwashers, ensuring a modern and convenient living experience. Our secure community is designed to provide peace of mind along with top-tier amenities, including in-apartment dishwashers that make everyday chores hassle-free.\n\nWithin the serene Rosemont Downs vicinity, our apartments feature large bedrooms, stylish loft layouts, and practical washer/dryer hookups. Enjoy the luxury of walk-in closets and unwind at our on-site pool. Juniper blends security, practicality, and leisure, making it a premier choice for comfortable living in Sacramento.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments with Dishwasher 95826",
      "seo_description": "Explore gated community apartments with dishwashers in 95826 at Juniper, offering secure living and essential conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-rosemont-downs-juniper",
      "search_query": "1 bedroom apartments near Rosemont Downs",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments Near Rosemont Downs",
      "h2_subtitle": "Find spacious 1 bedroom apartments near Rosemont Downs at Juniper. Enjoy comfortable living in a vibrant community.",
      "page_copy": "Explore comfortable 1-bedroom apartments near Rosemont Downs at Juniper. Each apartment features spacious bedrooms, walk-in closets, and thoughtful layouts designed for everyday convenience.\nLocated in Sacramento, Juniper offers modern amenities including washer/dryer hookups, a refreshing pool, and unique loft-style layouts. Enjoy convenient apartment living with easy access to local destinations and nearby attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Near Rosemont Downs",
      "seo_description": "Explore 1 bedroom apartments near Rosemont Downs at Juniper, offering spacious and stylish living in a vibrant Sacramento community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-sacramento-county-juniper",
      "search_query": "2 bedroom apartments Sacramento County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Sacramento County",
      "h2_subtitle": "Explore spacious 2-bedroom apartments in Sacramento County at Juniper",
      "page_copy": "Discover spacious 2-bedroom apartments in Sacramento County at Juniper. Our thoughtfully designed residences feature large bedrooms, walk-in closets, and functional layouts that provide comfortable living spaces.\nLocated in the Rosemont Downs area, Juniper offers modern amenities including washer/dryer hookups, loft-style layouts, and a refreshing community pool. Experience convenient apartment living with comfortable features and easy access to Sacramento County destinations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Sacramento County",
      "seo_description": "Find spacious and modern 2-bedroom apartments in Sacramento County at Juniper, featuring comfortable layouts, amenities, and thoughtfully designed spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "3-bedroom-floorplans-sacramento-ca-juniper",
      "search_query": "3 bedroom floorplans in Sacramento CA",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Floorplans in Sacramento, CA",
      "h2_subtitle": "Discover spacious 3 bedroom floorplans in Sacramento, CA at Juniper.",
      "page_copy": "Experience comfortable living with 3 bedroom floorplans in Sacramento, CA, at Juniper. These spacious layouts feature large bedrooms, walk-in closets, and functional designs that provide flexibility and convenience.\nLocated in the Rosemont Downs neighborhood, Juniper offers modern amenities including washer/dryer hookups, a refreshing pool, and unique loft layout options. Enjoy thoughtfully designed apartments with comfortable features and convenient access to Sacramento destinations.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Floorplans in Sacramento, CA",
      "seo_description": "Explore spacious 3-bedroom floor plans at Juniper in Sacramento, CA, featuring functional layouts, comfortable living spaces, and modern apartment features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "4-bedroom-apartments-near-95826-juniper",
      "search_query": "4 bedroom apartments near 95826",
      "category": "Floorplan",
      "h1_title": "4 Bedroom Apartments Near 95826",
      "h2_subtitle": "Explore spacious 4 bedroom apartments near 95826 at Juniper",
      "page_copy": "Discover comfortable 4 bedroom apartments near the 95826 area at Juniper, featuring spacious layouts, large bedrooms, and walk-in closets. Thoughtfully designed interiors provide ample space, storage, and modern functionality.\nLocated in Rosemont Downs in Sacramento, Juniper offers convenient amenities including washer/dryer hookups, a spacious pool area, and unique loft-style layouts. Enjoy a comfortable living environment with features designed for everyday convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "4 Bedroom Apartments Near 95826",
      "seo_description": "Find spacious 4-bedroom apartments at Juniper near 95826, featuring flexible layouts, comfortable living spaces, and modern apartment amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "apartments-near-csu-sacramento-juniper",
      "search_query": "apartments near california state university sacramento",
      "category": "School",
      "h1_title": "Apartments Near California State University Sacramento",
      "h2_subtitle": "Live conveniently near California State University Sacramento at Juniper, offering comfort and modern amenities.",
      "page_copy": "Discover convenient apartment living at Juniper near California State University Sacramento. Located a short drive from campus, these residences offer spacious layouts with large bedrooms, walk-in closets, and features designed for everyday comfort.\nLocated in the Rosemont Downs area, Juniper provides modern amenities including washer/dryer hookups, a refreshing pool, and unique loft layouts. Enjoy comfortable living with convenient access to Sacramento destinations and nearby university areas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near California State University Sacramento",
      "seo_description": "Discover comfortable living at Juniper, offering convenient apartments near California State University Sacramento with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "apartments-near-uc-davis-medical-center-sacramento-juniper",
      "search_query": "apartments near UC Davis Medical Center Sacramento County",
      "category": "Hospital",
      "h1_title": "Apartments Near UC Davis Medical Center",
      "h2_subtitle": "Discover convenient living at Juniper, located near UC Davis Medical Center in Sacramento County.",
      "page_copy": "Explore the comfort and convenience of living at Juniper, offering well-appointed apartments near UC Davis Medical Center in Sacramento County. Ideal for healthcare professionals and students, Juniper provides a serene environment just a short distance from the bustling Medical Center.\n\nLocated in the welcoming neighborhood of Rosemont Downs, our community features spacious bedrooms, walk-in closets, and washer/dryer hookups to meet your everyday needs. Relax at our pool or enjoy the unique charm of our loft layouts. Juniper ensures that comfort meets convenience, making it the perfect choice for those affiliated with UC Davis Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UC Davis Medical Center",
      "seo_description": "Live comfortably at Juniper, offering spacious apartments near UC Davis Medical Center in Sacramento County with modern features and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "rentals-close-to-kaiser-permanente-sacramento-juniper",
      "search_query": "rentals close to Kaiser Permanente Sacramento Medical Center CA",
      "category": "Hospital",
      "h1_title": "Rentals Close to Kaiser Permanente Sacramento",
      "h2_subtitle": "Juniper offers ideal rentals close to Kaiser Permanente Sacramento Medical Center, providing a serene living experience.",
      "page_copy": "Experience the convenience of living at Juniper, offering rentals close to Kaiser Permanente Sacramento Medical Center. Our thoughtfully designed apartments are perfect for healthcare professionals and staff members who desire a nearby residence with great amenities.\n\nNestled in Rosemont Downs, Juniper features large bedrooms and walk-in closets, ensuring ample space and comfort. With washer/dryer hookups and an inviting pool, our community provides a hassle-free lifestyle. The loft-style layouts add a touch of elegance, making Juniper a top choice for those working at Kaiser Permanente Sacramento Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Kaiser Permanente Sacramento",
      "seo_description": "Discover comfortable rentals at Juniper, close to Kaiser Permanente Sacramento Medical Center, featuring modern amenities in Rosemont Downs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "apartments-near-mckinley-park-sacramento-juniper",
      "search_query": "apartments near McKinley Park Sacramento",
      "category": "Park",
      "h1_title": "Apartments Near McKinley Park Sacramento",
      "h2_subtitle": "Juniper offers a delightful home base near McKinley Park in Sacramento, equipped with modern amenities.",
      "page_copy": "Find comfortable apartment living at Juniper, conveniently located near McKinley Park in Sacramento. Enjoy easy access to green spaces, local attractions, and outdoor activities while being close to everything the area has to offer.\nLocated in Rosemont Downs, Juniper offers spacious apartments with large bedrooms, walk-in closets, washer/dryer hookups, and a refreshing pool. Unique loft-style layouts provide a modern touch, creating a comfortable place to call home near McKinley Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McKinley Park Sacramento",
      "seo_description": "Discover Juniper's spacious apartments near McKinley Park Sacramento, offering modern living and amenities in a tranquil setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "living-close-to-river-bend-park-95826-juniper",
      "search_query": "living close to River Bend Park 95826",
      "category": "Park",
      "h1_title": "Living Close to River Bend Park 95826",
      "h2_subtitle": "Juniper offers comfortable living just minutes from River Bend Park in the 95826 area",
      "page_copy": "Enjoy comfortable apartment living near River Bend Park in the vibrant 95826 area at Juniper Apartments. Residents can enjoy convenient access to nearby trails, picnic areas, and outdoor spaces, offering opportunities to relax and enjoy the surrounding area.\n\nLocated in the Rosemont Downs neighborhood, Juniper features spacious apartments with large bedrooms, walk-in closets, washer/dryer hookups, and a refreshing pool. Loft-style layouts add a unique touch, creating a comfortable home base near River Bend Park and all that Sacramento has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to River Bend Park 95826",
      "seo_description": "Enjoy Juniper's modern living near River Bend Park in 95826, with spacious apartments and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "rosemont-downs-apartments-close-to-hagan-park",
      "search_query": "Rosemont Downs apartments close to Hagan Community Park",
      "category": "Park",
      "h1_title": "Rosemont Downs Apartments Near Hagan Park",
      "h2_subtitle": "Discover spacious Rosemont Downs apartments close to Hagan Community Park, offering a blend of comfort and convenience.",
      "page_copy": "Welcome to Juniper, offering comfortable apartments in Rosemont Downs near Hagan Community Park. Enjoy convenient access to outdoor spaces, sports fields, playgrounds, and walking paths while staying close to local attractions.\nJuniper features thoughtfully designed homes with spacious bedrooms, walk-in closets, washer/dryer hookups, and a refreshing pool. Unique loft layouts add a modern touch, creating a comfortable living experience in a convenient location near Hagan Community Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rosemont Downs Apartments Near Hagan Park",
      "seo_description": "Explore spacious Juniper apartments in Rosemont Downs, close to Hagan Community Park, with great amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "apartments-near-howe-community-park-sacramento-county",
      "search_query": "apartments near Howe Community Park Sacramento County",
      "category": "Park",
      "h1_title": "Apartments Near Howe Community Park Sacramento",
      "h2_subtitle": "Juniper offers comfortable apartment living near Howe Community Park in Sacramento County, with convenient access to nearby outdoor spaces, local attractions, and recreational areas.",
      "page_copy": "Discover apartment living at Juniper, conveniently located near Howe Community Park in Sacramento County. Enjoy easy access to nearby outdoor spaces, recreational areas, and local attractions while staying connected to the surrounding area.\nLocated in the Rosemont Downs neighborhood, Juniper offers spacious apartments with large bedrooms, walk-in closets, washer/dryer hookups, and a refreshing pool. Unique loft layouts add a modern touch, creating a welcoming living environment close to parks, amenities, and destinations throughout Sacramento County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Howe Community Park Sacramento",
      "seo_description": "Experience modern living at Juniper, close to Howe Community Park in Sacramento County, offering spacious apartments and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "ancil-hoffman-park-nearby-apartments-sacramento",
      "search_query": "Ancil Hoffman Park nearby apartments Sacramento",
      "category": "Park",
      "h1_title": "Ancil Hoffman Park Nearby Apartments",
      "h2_subtitle": "Juniper provides stylish Sacramento apartments near Ancil Hoffman Park, perfect for nature lovers and outdoor activities.",
      "page_copy": "Experience the best of Sacramento living at Juniper, where you'll find beautifully designed apartments nearby Ancil Hoffman Park. Known for its expansive golf course and scenic trails, Ancil Hoffman Park offers a great escape into nature just a short drive from our community.\n\nLocated in the tranquil Rosemont Downs area, Juniper's spacious apartments are equipped with large bedrooms and walk-in closets. Enjoy the convenience of washer/dryer hookups and unwind by our inviting pool. With distinctive loft layouts, Juniper combines comfort and style, offering a wonderful home near Ancil Hoffman Park in Sacramento.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ancil Hoffman Park Nearby Apartments",
      "seo_description": "Discover Juniper's stylish apartments near Ancil Hoffman Park, Sacramento, offering comfort and outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "apartments-near-university-65th-street-station",
      "search_query": "apartments near University/65th Street Station Sacramento",
      "category": "Transit",
      "h1_title": "Apartments Near University/65th St Station",
      "h2_subtitle": "Explore convenient living at Juniper, with apartments near University/65th Street Station in Sacramento, perfect for commuters.",
      "page_copy": "Welcome to Juniper, offering comfortable apartments near University/65th Street Station in Sacramento, an excellent choice for those who prioritize easy access to public transportation. The proximity to this station ensures a seamless commute, whether you're heading to work or exploring the vibrant city.\n\nNestled in the serene Rosemont Downs neighborhood, Juniper boasts spacious living spaces with large bedrooms and expansive walk-in closets. Enjoy modern amenities like washer/dryer hookups and a refreshing pool, enhancing your living experience. Our unique loft layouts provide a stylish touch, making Juniper a top choice for those valuing convenience and comfort near University/65th Street Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University/65th St Station",
      "seo_description": "Find comfort and convenience at Juniper, near University/65th Street Station, Sacramento, where style meets easy commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "apartments-close-to-mather-field-mills-station",
      "search_query": "apartments close to Mather Field/Mills Station Rosemont Downs",
      "category": "Transit",
      "h1_title": "Apartments Close to Mather Field/Mills Station",
      "h2_subtitle": "Modern Apartments Near Mather Field/Mills Station in Rosemont Downs",
      "page_copy": "Juniper offers comfortable apartment living near Mather Field/Mills Station in the Rosemont Downs area. Enjoy convenient access to public transportation options and nearby destinations throughout Sacramento.\nOur community features spacious apartments with large bedrooms, walk-in closets, washer/dryer hookups, a refreshing pool, and unique loft layouts. Juniper combines modern features and comfortable spaces in a convenient location near Mather Field/Mills Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mather Field/Mills Station",
      "seo_description": "Experience convenient living at Juniper, near Mather Field/Mills Station in Rosemont Downs, offering style and connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166809",
      "source": "custom",
      "page_item_url": "juniper-apartments-near-watt-manlove-station",
      "search_query": "Juniper apartments proximity to Watt/Manlove Station Sacramento County",
      "category": "Transit",
      "h1_title": "Juniper Apartments Near Watt/Manlove Station",
      "h2_subtitle": "Explore Juniper's prime location close to Watt/Manlove Station in Sacramento County, offering easy commuting and vibrant living.",
      "page_copy": "Juniper Apartments offer a convenient location near Watt/Manlove Station in Sacramento County, providing easy access to public transportation options and nearby destinations.\nLocated in the Rosemont Downs area, Juniper features spacious apartments with modern comforts, including large bedrooms, walk-in closets, washer/dryer hookups, and a swimming pool. Unique loft layouts add a contemporary touch, creating a comfortable living environment near Watt/Manlove Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Juniper Apartments Near Watt/Manlove Station",
      "seo_description": "Discover Juniper's convenient living, near Watt/Manlove Station in Sacramento County, blending comfort with easy commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4815"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10714993928"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5842GSZP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "493RMP"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('yaPkiZDaM3Sy1O8GLW')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "33840265131"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/9zw4z5ngv87"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "01525033"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Juniper/scheduletourwidget/xmWLwMSj6xqGLTIAeP/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlF5WDlwd3QrWERRcktldUtCR1BUZkE9PSIsInZhbHVlIjoibjR0c1crOEV0bUtWT0pSd3l4N2VIQT09IiwibWFjIjoiNjE5MjMwNmM4YWNjMjBkMWQ3NGVmNTE4ZjVhY2JiZmU3NDljYWMzZjBkZTZjMWNkZWMyMWMzYmMwODhhZGE2OCJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "4815",
  "custom_repli_id": "10714993928",
  "custom_google_gtm_id": "GTM-5842GSZP",
  "custom_rollout_phase": "Pathfinder 1",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "493RMP",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('yaPkiZDaM3Sy1O8GLW')</script>",
  "custom_hubspot_company_id": "33840265131",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/9zw4z5ngv87",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "01525033",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Juniper/scheduletourwidget/xmWLwMSj6xqGLTIAeP/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlF5WDlwd3QrWERRcktldUtCR1BUZkE9PSIsInZhbHVlIjoibjR0c1crOEV0bUtWT0pSd3l4N2VIQT09IiwibWFjIjoiNjE5MjMwNmM4YWNjMjBkMWQ3NGVmNTE4ZjVhY2JiZmU3NDljYWMzZjBkZTZjMWNkZWMyMWMzYmMwODhhZGE2OCJ9",
  "custom_audioeye_site_id": "cd6c30ad-45e6-4018-a7b2-3204ca489133",
  "custom_audioeye_site_hash": "388c7398cbc1255fbbc11651a766ffba"
};

export const generatedAt = '2026-10-08T20:12:11.516Z';
